const initExplainTable = () => {
  const cellsExplainTable = document.querySelectorAll('.explain-table td');
  if (cellsExplainTable.length > 0) {
    cellsExplainTable.forEach((cell) => {
      cell.addEventListener('click', (event) => {
        document.querySelector('.middle-row').innerHTML = `<td class="td-answer" colspan="3">${cell.dataset.define.toUpperCase()}</td>`;
      });
    });
    document.addEventListener("click", (event) => {
      const explainTable = document.querySelector(".explain-table");
      let targetElement = event.target;

      do {
        if (targetElement == explainTable) {
          return;
        }
        targetElement = targetElement.parentNode;
      } while (targetElement);
      document.querySelector('.middle-row').innerHTML = '';
    });
  }
}

export { initExplainTable };
